// This file is auto-generated don't edit it!
import { Component } from '@angular/core';

@Component({
    selector: 'ui-checkbox-docs',
    templateUrl: './checkbox.docs.generated.html',
})
export class UICheckboxDocs { }
